function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFormatImg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.586 2H5c-1 0-1 .816-1 .816V21.5s0 1 1.137 1h14c1.101 0 .863-1 .863-1V8.414a1 1 0 0 0-.293-.707l-5.414-5.414A1 1 0 0 0 13.586 2M5 21.5V3h9v5h5v13.5Zm0 0",
  style: {
    stroke: "none",
    fillRule: "evenodd",
    fill: "#a3197a",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 12h10v6H7Zm1 1h8v4H8Zm.5 4 2.5-3.102 2 2.403 1-1.102L15.5 17Zm1.95-3a.75.75 0 1 0-1.501 0 .75.75 0 0 0 1.5 0",
  style: {
    stroke: "none",
    fillRule: "evenodd",
    fill: "#a3197a",
    fillOpacity: 1
  }
}));
export default SvgFormatImg;